module.exports = __webpack_public_path__ + "static/media/img15.912f26b9.jpg";